import { Box, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import {
    EntityInstancePath,
    updateEntityInstancePath,
} from '../../../redux/slices/entityInstanceSlice'
import { CloseOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

const Path: React.FC = () => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const path = useAppSelector((state) => state.entityInstance.path)

    const onClickPath = (index: number) => {
        let updatedPath = [...path]
        updatedPath = updatedPath.slice(0, index + 1)
        dispatch(
            updateEntityInstancePath({
                path: updatedPath,
                isFirst: false,
                hasStartStep: false,
            }),
        )
    }

    return (
        <Box>
            {path?.length > 1 ? (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '20px',
                    }}
                >
                    {' '}
                    {path.map((p: EntityInstancePath, index: number) => (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            key={index + p.entityId}
                        >
                            {index !== 0 ? (
                                <Box sx={{ margin: '0px 5px' }}>
                                    <Typography
                                        fontSize="16px"
                                        fontWeight="600"
                                    >
                                        /
                                    </Typography>
                                </Box>
                            ) : (
                                <></>
                            )}
                            <Box
                                sx={{
                                    cursor: 'pointer',
                                }}
                            >
                                {index + 1 === path.length && index !== 0 ? (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            background: '#e0e0e0',
                                            padding: '5px 10px',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <Box onClick={() => {}} id={p.pathName}>
                                            <Typography
                                                fontSize="16px"
                                                fontWeight="600"
                                                sx={{
                                                    '&:hover': {
                                                        textDecoration:
                                                            'underline',
                                                    },
                                                }}
                                            >
                                                {t(p.pathName)}
                                            </Typography>
                                        </Box>

                                        <Box
                                            id={
                                                p.pathName +
                                                '-relation-close-button'
                                            }
                                            onClick={() =>
                                                onClickPath(index - 1)
                                            }
                                            sx={{
                                                marginLeft: '5px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <CloseOutlined
                                                sx={{
                                                    color: '#747474',
                                                    fontSize: '20px',
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                ) : (
                                    <Box
                                        onClick={() => onClickPath(index)}
                                        id={p.pathName}
                                    >
                                        <Typography
                                            fontSize="16px"
                                            fontWeight="600"
                                            sx={{
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                            }}
                                        >
                                            {t(p.pathName)}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    ))}
                </Box>
            ) : null}
        </Box>
    )
}

export default Path
